// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    updatePrivacyPolicy as updatePrivacyPolicyAPI,
} from '../../helpers/';

import { privacyPolicyApiResponseError, privacyPolicyApiResponseSuccess } from './actions';
import { PrivacyPolicyActionTypes } from './constants';

function* updatePrivacyPolicy({ payload: privacyPolicy }) {
    try {
        const response = yield call(updatePrivacyPolicyAPI, { ...privacyPolicy })
        const privacyPolicyItem = response.data.data
        yield put(privacyPolicyApiResponseSuccess(PrivacyPolicyActionTypes.UPDATE_PRIVACY_POLICY, privacyPolicyItem))
    } catch (error) {
        yield put(privacyPolicyApiResponseError(PrivacyPolicyActionTypes.UPDATE_PRIVACY_POLICY, error))
    }
}

export function* watchUpdatePrivacyPolicy(): any {
    yield takeEvery(PrivacyPolicyActionTypes.UPDATE_PRIVACY_POLICY, updatePrivacyPolicy)
}

function* privacyPolicySaga(): any {
    yield all([
        fork(watchUpdatePrivacyPolicy)
    ]);
}

export default privacyPolicySaga;
